var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thumb",class:_vm.onActive,style:({
      backgroundImage: `url( ${_vm.thumbnail})`,
      cursor: 'pointer'
    }),on:{"click":_vm.changeThumbnail}})
}
var staticRenderFns = []

export { render, staticRenderFns }